import React, {PropsWithChildren} from "react";
import {SCENE, WithScene} from "./interfaces/UX";
import {WithErrorHandling} from "./interfaces/ErrorHandling";
import {ActionButton} from "./components/action-button/ActionButton";

export const HtmlVisualization = (props: PropsWithChildren<WithScene & WithErrorHandling>) => {

    return (
        <>
            <div className={"jumbotron"}>
                <h1 className={"display-4"}>MeasAR</h1>
                <p>How big? Just measAR it!</p>
                <hr className="my-4" />
            </div>
            <ActionButton onClick={() => props.changeScene(SCENE.MAIN)}>Start!</ActionButton>
        </>
    );
};
